import Block from '@/classes/templates/Block'

export default class Blocks extends Array {
  constructor (blocks, ...rest) {
    Array.isArray(blocks) ? super(...blocks.map(block => new Block(block)).filter(block => block.component_path)) : super(...rest)
  }

  get all () {
    return this.getNestedBlocks(this)
  }

  get (name) {
    return this.find(block => block.name === name)
  }

  getNestedBlocks (blocks) {
    return blocks.flatMap(block => {
      const nestedBlocks = block.configuration ? this.getNestedBlocks(block.configuration.blocks) : []

      return [block, ...nestedBlocks]
    })
  }
}
